import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import * as Sentry from '@sentry/angular-ivy'
import packageJson from '../package.json'

declare global {
  interface Window {
    _depoto: any
    CYPRESS?: {
      mutation?: any
      response?: any
      errors?: any
    }
  }
}

Sentry.init({
  dsn: environment.sentryDsn,
  environment: environment.sentryEnv,
  enabled: environment.sentryEnv === 'PROD',
  release: `hs-client@${packageJson.version}#${packageJson.lastCommit}`,
  ignoreErrors: [
    /Failed to fetch/i,
    /NetworkError/i,
    /Load failed/i,
    /The operation was aborted/i,
    /The user aborted a request/i,
    /Fetch API cannot load/i,
    /Network request failed/i,
    'Failed to fetch',
    'NetworkError when attempting to fetch resource.',
    'Load failed',
    'The operation was aborted',
    'The user aborted a request',
  ],
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [environment.urlDeployment],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

if (environment.production) {
  enableProdMode()
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err))
